/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiAttributionModel;
(function (ApiAttributionModel) {
    ApiAttributionModel["NO_MODEL_SELECTED"] = "NO_MODEL_SELECTED";
    ApiAttributionModel["EBA"] = "EBA";
    ApiAttributionModel["FIRST"] = "FIRST";
    ApiAttributionModel["LAST"] = "LAST";
    ApiAttributionModel["LAST_NON_DIRECT"] = "LAST_NON_DIRECT";
    ApiAttributionModel["LINEAR"] = "LINEAR";
    ApiAttributionModel["POSITION_BASED"] = "POSITION_BASED";
    ApiAttributionModel["IMPACTED"] = "IMPACTED";
    ApiAttributionModel["CUSTOM"] = "CUSTOM";
})(ApiAttributionModel || (ApiAttributionModel = {}));
export function ApiAttributionModelFromJSON(json) {
    return ApiAttributionModelFromJSONTyped(json, false);
}
export function ApiAttributionModelFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiAttributionModelToJSON(value) {
    return value;
}
